import { Suspense, lazy } from 'react';

import { Loader } from 'shared/ui/Loader';

const SupplierCategoryMappings = lazy(
  () => import('./SupplierCategoryMappings'),
);

export default () => (
  <Suspense fallback={<Loader />}>
    <SupplierCategoryMappings />
  </Suspense>
);
